import type { ButtonProps } from '@mui/material';
import { Button } from '@mui/material';
import { forwardRef } from 'react';

import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => {
  return {
    root: {
      borderRadius: '20px',
      cursor: 'pointer',
    },
  };
});

export type Or2ButtonProps = ButtonProps;

export const Or2Button = forwardRef<HTMLButtonElement, Or2ButtonProps>(
  (
    {
      variant = 'contained',
      disableElevation = true,
      children,
      className,
      ...other
    },
    ref,
  ) => {
    const { classes, cx } = useStyles();

    return (
      <Button
        ref={ref}
        className={cx(classes.root, className)}
        variant={variant}
        disableElevation={disableElevation}
        {...other}
      >
        {children}
      </Button>
    );
  },
);

Or2Button.displayName = 'Or2Button';
